module.exports = __webpack_public_path__ + "img/zh.4131fb2c.png";